import React, { useState } from "react";
import frame from "../assets/images/fancy-frame.png";
const ResultModal = ({ isOpen, drawingURL, prompt, onSubmit, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl h-[90vh] overflow-y-scroll p-6">
        <h2 className="text-2xl font-bold text-center text-indigo-600 mb-2">
          You're quite the artist!
        </h2>
        <h4 className="text-center text-sm text-indigo-500 mb-4">
          Submit this drawing for a chance to win a prize, plus you'll get a
          copy to show off to your friends!
        </h4>

        <div className="mb-6 overflow-hidden w-[400px] mx-auto">
          <div className="relative">
            <img src={frame} alt="Fancy Frame" className="w-full" />
            <div className="absolute inset-0 w-[75%] h-[80%] m-auto object-contain">
              <img src={drawingURL} alt="Your drawing" />
              <p className="text-center text-base italic font-serif text-gray-600 mt-2">
                "{prompt}"
              </p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Name
            </label>
            <input
              type="text"
              id="name"
              placeholder="Salvador Dali-matian"
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              value={formData.name}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, name: e.target.value }))
              }
            />
          </div>

          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              required
              placeholder="modern.art@its-finest.com"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              value={formData.email}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, email: e.target.value }))
              }
            />
          </div>

          <div className="flex gap-4 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-gray-100 text-gray-700 font-semibold py-4 px-4 rounded-full hover:bg-gray-200 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 bg-gradient-to-br from-pink-500 to-yellow-400 text-white font-semibold py-4 px-4 rounded-full hover:opacity-90 transition-opacity"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResultModal;
